import { Color, Icon } from '@cobalt/cobalt-react-components'
import {
  MFA_TOTP_NAME,
  MFA_WEB_AUTHN_NAME,
  MFA_SELECTOR_TOTP_DESCRIPTION,
  MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
  MFA_SETTINGS_TITLE
} from './ui.labels'

export const RECOVERY_OTP = 'RECOVERY_OTP'
export const TOTP = 'TOTP'
export const WEB_AUTHN = 'WEB_AUTHN'

export const MFATypes = {
  RECOVERY_OTP,
  TOTP,
  WEB_AUTHN
}

export const Properties = {
  [RECOVERY_OTP]: {
    name: MFA_SETTINGS_TITLE
  },
  [WEB_AUTHN]: {
    name: MFA_WEB_AUTHN_NAME,
    icon: Icon.SECURITY_KEY,
    color: Color.primary[600]
  },
  [TOTP]: {
    name: MFA_TOTP_NAME,
    icon: Icon.PHONELINK_LOCK,
    color: Color.green[600]
  }
}

export const AvailableMFA = {
  [WEB_AUTHN]: {
    ...Properties[WEB_AUTHN],
    description: MFA_SELECTOR_WEB_AUTHN_DESCRIPTION
  },
  [TOTP]: {
    ...Properties[TOTP],
    description: MFA_SELECTOR_TOTP_DESCRIPTION
  }
}
